interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string; // Testo opzionale accanto al toggle
  disabled?: boolean;
}

export const Toggle = ({ checked, onChange, label, disabled = false }: ToggleProps) => {
  return (
    <div className={`flex items-center justify-between w-full ${disabled ? 'opacity-50 pointer-events-none' : ''}`}>
      {/* Label con gestione testo lungo (non schiaccia il toggle) */}
      {label && (
        <span 
          className="text-sm font-medium text-gray-700 flex-1 min-w-0 truncate mr-3 cursor-pointer select-none"
          onClick={() => !disabled && onChange(!checked)}
        >
          {label}
        </span>
      )}

      {/* Il Toggle vero e proprio */}
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        onClick={() => !disabled && onChange(!checked)}
        className={`
          relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent 
          transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500 focus-visible:ring-offset-2
          ${checked ? 'bg-emerald-500' : 'bg-gray-200'}
        `}
      >
        <span className="sr-only">{label || 'Toggle'}</span>
        <span
          aria-hidden="true"
          className={`
            pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 
            transition duration-200 ease-in-out
            ${checked ? 'translate-x-5' : 'translate-x-0'}
          `}
        />
      </button>
    </div>
  );
};